import { DataBean } from "../DataBean";

export class BudgetCostingCenter extends DataBean {

    public async getBudgetCostingCenterCatalog(idCostingCenter: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getBudgetCostingCenterCatalog_Number", [idCostingCenter]);
    }

    public async deleteBudgetCostingCenter(idBudgetCostingCenter: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteBudgetCostingCenter_Number", [idBudgetCostingCenter]);
    }

    public async addBudgetCostingCenter(idCostingCenter: number, budgetIDStr: string, expAccountantIDStr: string): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.accountant.BudgetCostingCenter_addBudgetCostingCenter_Number_String_String", [idCostingCenter, budgetIDStr, expAccountantIDStr]);
    }

    public async updateBudgetCostingCenter(bean: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.accountant.BudgetCostingCenter_updateBudgetCostingCenter_com.quickdataerp.bean.accountant.BudgetCostingCenter", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.quickdataerp.bean.accountant.BudgetCostingCenter"
            }
        ]);
    }
    public async getCostingCenterMethodTypes(arg: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getCostingCenterMethodTypes_Number", [arg]);
    }
    public async getCostingCenterMethodCatalog(idCostingCenterMethod: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getCostingCenterMethodCatalog_Number", [idCostingCenterMethod]);
    }
    public async getUBLCostingCenterCatalog(idUBLItem:number,issueDate:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getUBLCostingCenterCatalog_Number_java.util.Date", [idUBLItem,issueDate]);
    }
    public async addUBLCostingCenter4(idUBLItem:number,issueDate:any,idCostingCenter:number,percentValue:number,accountantIDStr:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.ubl.UBLCostingCenter_addUBLCostingCenter_Number_java.util.Date_Number_Number_String", [idUBLItem,issueDate,idCostingCenter,percentValue,accountantIDStr]);
    }
    public async deleteUBLCostingCenter(idUBLCostingCenter:number,issueDate:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteUBLCostingCenter_Number_java.util.Date", [idUBLCostingCenter,issueDate]);
    }
    public async getCostingCenterSumValue(idCostingCenterMethod:number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "double_getCostingCenterSumValue_Number", [idCostingCenterMethod]);
    }
    public async getUBLCostingCenterSum(idUBLItem:number,issueDate:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "double_getUBLCostingCenterSum_Number_java.util.Date", [idUBLItem,issueDate]);
    }

    public async importCostingCenterModel(idUBLItemInvoice: number, issueDate: any, filename: string, directory: string, dataStore: string): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_importCostingCenterModel_Number_java.util.Date_String_String_String", [idUBLItemInvoice,issueDate, filename, directory, dataStore]);
    }

}